import React, { memo } from 'react';
import clsx from 'clsx';
import { SearchSelectItem } from './SearchSelect';

interface ItemProps {
  isSelected: boolean;
  isHovered: boolean;
  item: SearchSelectItem;
  onItemSelected: (item: SearchSelectItem) => void;
  buildTemplate: (item: SearchSelectItem) => React.ReactElement;
}

const ListItem = ({ item, onItemSelected, isSelected, isHovered, buildTemplate }: ItemProps) => {
  const handleItemSelect = () => {
    return onItemSelected(item);
  };

  const { value } = item;

  return (
    <li
      id={`option-for-${value}`}
      onClick={handleItemSelect}
      onKeyDown={handleItemSelect}
      className={clsx(
        'text-black-default cursor-pointer font-effra p-3 border-transparent',
        'hover:bg-gold hover:border-primary-500 hover:shadow-dd-item-active',
        'focus:outline-none focus-visible:ring',
        isSelected ? 'bg-gold border-t border-b border-primary-500 shadow-dd-item-active pl-4' : 'border-l-4',
        isHovered && 'bg-gold border-primary-500 shadow-dd-item-active'
      )}
      role='option'
      aria-selected={isSelected}
      tabIndex={-1}
    >
      {buildTemplate(item)}
    </li>
  );
};

export default memo(ListItem);
